import { render, staticRenderFns } from "./AvatarCropper.vue?vue&type=template&id=410bf9a2&lang=pug&"
import script from "./AvatarCropper.vue?vue&type=script&lang=js&"
export * from "./AvatarCropper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports